<template>
  <b-modal
      v-model="isVisible"
      id="package-prospect-settings-modal"
      title="Ustawienia Prospektu"
      title-class="font-18 fw-bold text-primary"
      size="lg"
      hide-footer
  >
    <div class="card shadow-sm mb-4 border-info">
      <div class="card-header bg-info-subtle text-info-emphasis">
        <h6 class="mb-0 fw-bold"><i class="fas fa-file-contract me-2"></i>Ustawienia Prospektu</h6>
      </div>
      <div class="card-body">
        <div class="row g-3">

          <div class="col-md-6">
            <label class="form-label">Data wygaśnięcia</label>
            <input type="datetime-local" :class="prospectExpiryDateInputClass" v-model="prospectExpiryDateFormatted">
            <div class="invalid-feedback">Data wygaśnięcia prospektu jest wymagana</div>
          </div>
          <div class="col-md-6">
            <label v-if="hasInitialData" class="form-label">Data zamknięcia</label>
            <!-- Nie mozna edytować, zamknięcie będzie updatowana automatycznie po realnym zamknieciu prospektu przez system -->
            <input v-if="hasInitialData" type="datetime-local" class="form-control" v-model="prospectCloseDateFormatted" :disabled="true">
          </div>

          <div class="col-md-4">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="prospectAllowModifyAmount">
              <label class="form-check-label">Zezwalaj na zmianę ilości</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="prospectAllowAddProducts">
              <label class="form-check-label">Zezwalaj na dodawanie produktów</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="prospectAllowPurchasePrice">
              <label class="form-check-label">Zezwalaj na widok cen zakupu</label>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <button type="button" class="btn btn-primary px-4" @click="saveSettings">
        <i class="fas fa-save me-1"></i> Zapisz
      </button>
    </div>
  </b-modal>
</template>

<script>
import { BModal } from "bootstrap-vue-next";
import dateFormat from "dateformat";

export default {
  name: "PackageProspectSettingsModal",
  components: {
    BModal
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    initialProspectData: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  emits: ["update:showModal", "onSaveProspectSettings"],
  data() {
    return {
      prospectExpiryDateFormatted: null,
      prospectCloseDateFormatted: null,
      prospectAllowModifyAmount: false,
      prospectAllowAddProducts: false,
      prospectAllowPurchasePrice: false,
      validation: {
        prospectExpiryDate: true
      }
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.showModal;
      },
      set(val) {
        this.$emit("update:showModal", val);
      }
    },
    hasInitialData() {
      return this.initialProspectData && Object.keys(this.initialProspectData).length > 0;
    },
    prospectExpiryDateInputClass() {
      if (this.validation.prospectExpiryDate) {
        return "form-control";
      } else {
        return "form-control is-invalid";
      }
    }
  },
  watch: {
    initialProspectData: {
      handler(newVal) {
        if (newVal) {
          this.prospectExpiryDateFormatted = this.timestampToInput(newVal.prospectExpiryDate);
          this.prospectCloseDateFormatted = this.timestampToInput(newVal.prospectCloseDate);
          this.prospectAllowModifyAmount = !!newVal.prospectAllowModifyAmount;
          this.prospectAllowAddProducts = !!newVal.prospectAllowAddProducts;
          this.prospectAllowPurchasePrice = !!newVal.prospectAllowPurchasePrice;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    timestampToInput(ts) {
      if (!ts) return null;
      return dateFormat(new Date(ts), "yyyy-mm-dd'T'HH:MM");
    },
    inputToTimestamp(dateStr) {
      if (!dateStr) return null;
      return new Date(dateStr).getTime();
    },
    validate() {
      this.validation.prospectExpiryDate = !!this.prospectExpiryDateFormatted;
      return this.validation.prospectExpiryDate;
    },
    saveSettings() {
      if (!this.validate()) return;

      const settings = {
        prospectExpiryDate: this.inputToTimestamp(this.prospectExpiryDateFormatted),
        prospectCloseDate: this.inputToTimestamp(this.prospectCloseDateFormatted),
        prospectAllowModifyAmount: this.prospectAllowModifyAmount,
        prospectAllowAddProducts: this.prospectAllowAddProducts,
        prospectAllowPurchasePrice: this.prospectAllowPurchasePrice
      };

      this.$emit("onSaveProspectSettings", settings);
      this.isVisible = false;
    }
  }
};
</script>

<style scoped>
.required:after {
  content: " *";
  color: red;
}

.card-header {
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.form-control:disabled, .form-select:disabled, .form-check-input:disabled {
  background-color: #f8f9fa;
  opacity: 0.8;
  cursor: not-allowed;
}

.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
</style>
